import { useEffect, useState } from 'react';

export const useChatDropdown = () => {
    const [showChatDropdown, setShowChatDropdown] = useState(false);

    // Handle outside clicks to close dropdown
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as Element;
            if (showChatDropdown && !target.closest('.chat-dropdown-container')) {
                setShowChatDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showChatDropdown]);

    const toggleChatDropdown = () => {
        setShowChatDropdown(!showChatDropdown);
    };

    const closeChatDropdown = () => {
        setShowChatDropdown(false);
    };

    return {
        showChatDropdown,
        toggleChatDropdown,
        closeChatDropdown,
    };
};
